import React, { useMemo,useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,Label,
  Row,
  Col
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
const ManageInvoice = ({ invoiceData = [], orderId,fetchInvoiceDetails }) => {

  const baseurl = process.env.REACT_APP_BASE_URL;
const imgurl=process.env.REACT_APP_IMAGE_URL;
  const [shippingModal, setShippingModal] = useState(false);
  const [ewayModal, setEwayModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
const [loading, setLoading] = useState(false);
const [ewayLoading, setEwayLoading] = useState(false); 
const [invoiceModal, setInvoiceModal] = useState(false); 
const [outwardList, setOutwardList] = useState([]); 
const [outwardSelectedItems, setOutwardSelectedItems] = useState([]);
const [isShippingView, setIsShippingView] = useState(false);
const [isEwayView, setIsEwayView] = useState(false);
const handleCheckboxChange = (id) => {
  console.log("Clicked:", id);

  setOutwardSelectedItems(prev => {
    const exists = prev.includes(id);
    console.log("Previous:", prev, "Exists:", exists);

    let updated;

    if (exists) {
      updated = prev.filter(item => item !== id);
    } else {
      updated = [...prev, id];
    }

    console.log("Updated:", updated);
    return updated;
  });
};

  const handleGenerateInvoice=async ()=> { 
    try { 
      const res=await fetch(`${baseurl}/admin/customer/create-invoice`, 
        { method: "POST", 
          headers: { "Content-Type": "application/json" } , 
          body: JSON.stringify( { 
            order_id: orderId, 
            outward_item_ids: outwardSelectedItems, 
            user_id: 1 }) 
          }); 
          
          const data=await res.json(); 
          if (data.success) { 

            toast.success("Invoice Created Successfully");
            
            setInvoiceModal(false); 
           // setOutwardSelectedItems(null);
       
        fetchInvoiceDetails();
            // fetchOutwardForInvoice(); // refresh main list 
            } else { 
              alert(data.message); 
            } 
          } catch (err) { 
            console.error(err); 
          } 
        } ; 
      const downloadInvoicePDF = async (invoiceNo) => {
  try {
    const response = await fetch(
      `${baseurl}/admin/customer/invoice/${invoiceNo}`
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    window.open(url, "_blank");

  } catch (error) {
    console.error("Invoice download failed:", error);
  }
};
        
            const handleOpenInvoiceModal = async () => { 
  try { 
    const res = await fetch(`${baseurl}/admin/customer/outward-for-invoice/${orderId}`); 
    

   const result = await res.json();
console.log("API:", result);

const list = Array.isArray(result) ? result : result.data;

setOutwardList(list);


    setInvoiceModal(true); 
  } catch (err) { 
    console.error(err); 
  } 
};

  const [shippingForm, setShippingForm] = useState({
    courier_name: "",
    transporter_id: "",
    courier_doc_no: "",
    dispatch_date: "",
    no_of_box: ""
  });

  const [ewayForm, setEwayForm] = useState({
    sub_type: "",
    document_type: "",
    transport_mode: "",
    distance: "",
    vehicle_number: "",
    document_number: "",
    eway_bill_pdf: null
  });

  /* ---------------- Shipping Handlers ---------------- */

  const openShippingModal = (invoice) => {
    console.log("Selected Invoice:", invoice);
    setSelectedInvoice(invoice);
    setShippingForm(invoice);
    setShippingModal(true);
  };

  const saveShipping = async () => {
  try {
setLoading(true);
    if (!selectedInvoice?.id) {
      toast.error("Invoice not selected");
      return;
    }

    const res = await fetch(
      `${baseurl}/admin/customer/invoice/shipping-save`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          invoice_id: selectedInvoice.id,
          ...shippingForm
        })
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("Shipping Details Saved Successfully");

      // Optional: Refresh invoice list
       fetchInvoiceDetails();

      setShippingModal(false);

    } else {
      toast.error(data.message || "Something went wrong");
    }

  } catch (error) {
    console.error("Shipping Save Error:", error);
    toast.error("Server Error");
  }finally {
    setLoading(false);
  }
};


  /* ---------------- Eway Handlers ---------------- */

  const openEwayModal = (invoice) => {
    
    setSelectedInvoice(invoice);
    setEwayModal(true);
  };

 const saveEway = async () => {
  try {
    setEwayLoading(true);

    if (!selectedInvoice?.id) {
      toast.error("Invoice not selected");
      return;
    }

    if (!ewayForm.vehicle_number || !ewayForm.document_number) {
      toast.error("Please fill required fields");
      return;
    }

    // ✅ Create FormData
    const formData = new FormData();

    formData.append("invoice_id", selectedInvoice.id);
    formData.append("sub_type", ewayForm.sub_type || "");
    formData.append("document_type", ewayForm.document_type || "");
    formData.append("transport_mode", ewayForm.transport_mode || "");
    formData.append("distance", ewayForm.distance || "");
    formData.append("vehicle_number", ewayForm.vehicle_number || "");
    formData.append("document_number", ewayForm.document_number || "");

    // ✅ Append file
    if (ewayForm.eway_bill_pdf) {
      formData.append("eway_bill_pdf", ewayForm.eway_bill_pdf);
    }

    const res = await fetch(
      `${baseurl}/admin/customer/invoice/eway-save`,
      {
        method: "POST",
        body: formData // ✅ NOT JSON
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("Eway Bill Saved Successfully");
      fetchInvoiceDetails();
      setEwayModal(false);
    } else {
      toast.error(data.message || "Failed to save Eway Bill");
    }

  } catch (error) {
    console.error("Eway Save Error:", error);
    toast.error("Server Error");
  } finally {
    setEwayLoading(false);
  }
};


  /* ---------------- Table Columns ---------------- */

  const columns = useMemo(() => [
    {
      Header: "Sr",
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "Invoice No.",
      accessor: "invoice_no",
      Cell: ({ row }) => (
        <a
          href='#'
          rel="noopener noreferrer"
          className="fw-bold text-primary"
        >
          {row.original.invoice_no}
        </a>
      ),
    },
    {
      Header: "Order No.",
      accessor: "order_no",
      Cell: ({ row }) => (
        <a
          href='#'
          rel="noopener noreferrer"
          className="fw-bold text-primary"
        >
          {row.original.order_no}
        </a>
      ),
    },
    {
      Header: "Customer Name",
      accessor: "customer_name",
    },
    {
  Header: "Total Amount",
  Cell: ({ row }) => {
    const data = row.original;

    const toNum = (val) => Number(val) || 0;

const total =
  toNum(data.total_amount) +
  toNum(data.shipping_charge) +
  toNum(data.shipping_igst) +
  toNum(data.shipping_cgst) +
  toNum(data.shipping_sgst);

    return `₹ ${total.toLocaleString("en-IN")}`;
  },
},
    {
      Header: "Payment Status",
      accessor: "payment_status",
      Cell: ({ value }) => (
        <Badge color={value === "Received" ? "success" : "warning"}>
          {value || "Pending"}
        </Badge>
      ),
    },

    /* ---------------- Shipping Column ---------------- */

    {
  Header: "Shipping",
  Cell: ({ row }) => {
    const data = row.original;
    const shippingAdded = Number(data.shipping_added);
    const ewayStatus = data.eway_status;

    return (
      <div className="d-flex gap-2">

        {/* Add */}
        {shippingAdded === 0 && (
          <Button
            size="sm"
            color="success"
            onClick={() => openShippingModal(data)}
          >
            Add
          </Button>
        )}

        {/* Edit */}
        {shippingAdded > 0 &&
          (ewayStatus !== "Generated" ||
           ewayStatus === "Cancelled") && (
            <Button
              size="sm"
              color="warning"
              onClick={() => {setIsShippingView(false); openShippingModal(data)}}
            >
              Edit
            </Button>
          )}
  
        {/* View */}
        {shippingAdded > 0 && (
          <Button size="sm" color="info" onClick={() => {
      setSelectedInvoice(data);
      setShippingForm(data);
      setIsShippingView(true);
      setShippingModal(true);
    }}>
            View
          </Button>
        )}

      </div>
    );
  },
}
,

    /* ---------------- Eway Column ---------------- */

    {
      Header: "Eway Bill",
      Cell: ({ row }) => {
        const data = row.original;

        return (
          <div className="d-flex gap-2">

            {/* Add */}
            {data.shipping_added > 0 &&
              !data.eway_bill_number && (
                <Button size="sm" color="primary"
                  onClick={() => openEwayModal(data)}>
                  Add
                </Button>
              )}

            {/* Edit */}
            
              <Button size="sm" color="warning"
                onClick={() => {setIsEwayView(false); openEwayModal(data)}}>
                Edit
              </Button>
            

            {/* View */}
            {data.eway_bill_number && (
              <Button size="sm" color="info" onClick={() => {
      setSelectedInvoice(data);
      setEwayForm(data);
      setIsEwayView(true);   // View mode
      setEwayModal(true);
    }}>
                View
              </Button>
            )}

          </div>
        );
      }
    },{
      Header: "Action",
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <button
        type="button"
        className="btn btn-link text-primary p-0" title="Invoice"
        onClick={() =>
          downloadInvoicePDF(row.original.invoice_no)
        }
      >
        <i className="bx bx-receipt font-size-18"></i>
      </button>
          

          {/* <Link
            to={`/manage-invoices/edit/${row.original.id}`}
            className="text-warning"
          >
            <i className="bx bx-edit font-size-18"></i>
          </Link>

          <Link
            to={`/manage-invoices/eway/${row.original.id}`}
            className="text-success"
          >
            <i className="bx bx-receipt font-size-18"></i>
          </Link> */}
        </div>
      ),
    },

  ], []);

  return (
    <>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3"> <h5 className="mb-0">Manage Invoice</h5> <Button color="primary" onClick={handleOpenInvoiceModal} > <i className="bx bx-file me-1"></i> Create Invoice </Button> </div>
          <TableContainer
            columns={columns}
            data={invoiceData}
            isGlobalFilter={true}
            customPageSize={10}
          />
        </CardBody>
      </Card>

      {/* ---------------- Shipping Modal ---------------- */}

<Modal isOpen={shippingModal} toggle={() => setShippingModal(false)} size="lg">
  <ModalHeader toggle={() => setShippingModal(false)}>
    Shipping Details
  </ModalHeader>

  <ModalBody>
    <Row>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Courier Name</Label>
          <Input
            type="text"
            placeholder="Enter Courier Name"
            value={shippingForm.courier_name || ""}
            disabled={isShippingView}
            onChange={e =>
              setShippingForm({
                ...shippingForm,
                courier_name: e.target.value
              })
            }
          />
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Transporter ID</Label>
          <Input
            type="text"
            placeholder="Enter Transporter ID"
            value={shippingForm.transporter_id || ""}
            disabled={isShippingView}
            onChange={e =>
              setShippingForm({
                ...shippingForm,
                transporter_id: e.target.value
              })
            }
          />
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Courier Document No</Label>
          <Input
            type="text"
            placeholder="Enter Courier Document Number"
            value={shippingForm.courier_doc_no || ""}
            disabled={isShippingView}
            onChange={e =>
              setShippingForm({
                ...shippingForm,
                courier_doc_no: e.target.value
              })
            }
          />
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Dispatch Date</Label>
          <Input
            type="date"
           value={
    shippingForm.dispatch_date
      ? shippingForm.dispatch_date.split("T")[0]
      : ""
  }
            disabled={isShippingView}
            onChange={e =>
              setShippingForm({
                ...shippingForm,
                dispatch_date: e.target.value
              })
            }
          />
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Number of Boxes</Label>
          <Input
            type="number"
            placeholder="Enter No. of Boxes"
            disabled={isShippingView}
            value={shippingForm.no_of_box || ""}
            onChange={e =>
              setShippingForm({
                ...shippingForm,
                no_of_box: e.target.value
              })
            }
          />
        </div>
      </Col>

    </Row>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={() => setShippingModal(false)}>
      Cancel
    </Button>
    {!isShippingView && (
    <Button color="primary" onClick={saveShipping} disabled={loading}>
      {loading ? "Saving..." : "Save Shipping"} 
    </Button>
    )}
  </ModalFooter>
</Modal>
{/* ---------------- Eway Modal ---------------- */}

<Modal isOpen={ewayModal} toggle={() => setEwayModal(false)} size="lg">
  <ModalHeader toggle={() => setEwayModal(false)}>
    Eway Bill Details
  </ModalHeader>

  <ModalBody>
    <Row>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Sub Type</Label>
          <Input
            type="select"
            disabled={isEwayView}
            value={ewayForm.sub_type || ""}
            onChange={e =>
              setEwayForm({
                ...ewayForm,
                sub_type: e.target.value
              })
            }
          >
            <option value="">Select Sub Type</option>
            <option value="Supply">Supply</option>
            <option value="Export">Export</option>
            <option value="Job Work">Job Work</option>
          </Input>
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Document Type</Label>
          <Input
            type="select"
            disabled={isEwayView}
            value={ewayForm.document_type || ""}
            onChange={e =>
              setEwayForm({
                ...ewayForm,
                document_type: e.target.value
              })
            }
          >
            <option value="">Select Document Type</option>
            <option value="Invoice">Invoice</option>
            <option value="Bill of Supply">Bill of Supply</option>
            <option value="Delivery Challan">Delivery Challan</option>
          </Input>
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Mode of Transport</Label>
          <Input
            type="select"
            disabled={isEwayView}
            value={ewayForm.transport_mode || ""}
            onChange={e =>
              setEwayForm({
                ...ewayForm,
                transport_mode: e.target.value
              })
            }
          >
            <option value="">Select Mode</option>
            <option value="Road">Road</option>
            <option value="Rail">Rail</option>
            <option value="Air">Air</option>
            <option value="Ship">Ship</option>
          </Input>
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Distance (KM)</Label>
          <Input
            type="number"
            disabled={isEwayView}
            placeholder="Enter Distance in KM"
            value={ewayForm.distance || ""}
            onChange={e =>
              setEwayForm({
                ...ewayForm,
                distance: e.target.value
              })
            }
          />
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Vehicle Number</Label>
          <Input
            type="text"
            placeholder="Enter Vehicle Number"
            disabled={isEwayView}
            value={ewayForm.vehicle_number || ""}
            onChange={e =>
              setEwayForm({
                ...ewayForm,
                vehicle_number: e.target.value
              })
            }
          />
        </div>
      </Col>

      <Col md="6">
        <div className="mb-3">
          <Label className="form-label">Document / LR / RR No</Label>
          <Input
            type="text"
            disabled={isEwayView}
            placeholder="Enter Document Number"
            value={ewayForm.document_number || ""}
            onChange={e =>
              setEwayForm({
                ...ewayForm,
                document_number: e.target.value
              })
            }
          />
        </div>
        </Col>
        <Col md="6">
  <div className="mb-3">
    <Label className="form-label">Upload Eway Bill PDF</Label>
    <Input
      type="file"
      accept="application/pdf"
      //disabled={isEwayView}
      onChange={(e) => {
        setEwayForm({
          ...ewayForm,
          eway_bill_pdf: e.target.files[0] // store file
        });
      }}
    />
  </div>
  {ewayForm.eway_bill_pdf && (
  <a
    href={`${imgurl}${ewayForm.eway_bill_pdf}`}
    target="_blank"
    rel="noreferrer"
  >
    View PDF
  </a>
)}
</Col>
      

    </Row>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={() => setEwayModal(false)}>
      Cancel
    </Button>
    
    <Button color="primary" onClick={saveEway} disabled={loading}>
      {loading ? "Generating..." : "Generate Eway Bill"}
    </Button>
    
  </ModalFooter>
</Modal>

{/* 🔹 Invoice Modal */} 
<Modal isOpen={invoiceModal} toggle={() => setInvoiceModal(false)} size="lg" backdrop="static" > 
  <ModalHeader toggle={() => setInvoiceModal(false)}> Select Outward Items for Invoice </ModalHeader> 
  <ModalBody> {outwardList.length === 0 ? ( 
    <div className="text-center text-muted"> All outward items already invoiced. </div> ) : ( 
    <table className="table table-bordered"> 
    <thead> 
      <tr> 
        <th>Select</th> 
        <th>Outward No</th> 
        <th>Product</th> 
        <th>Qty</th> 
        <th>Price</th> 
        <th>Date</th> 
        </tr> 
    </thead> 
    <tbody> 
      {outwardList.map(item => ( 
        <tr key={item.outward_item_id}> 
        <td>
  {console.log(
    "ID:",
    item.outward_item_id,
    "Selected:",
    outwardSelectedItems
  )}
  <input
    type="checkbox"
 //   checked={outwardSelectedItems.includes(item.outward_item_id)}
    onChange={() =>
      handleCheckboxChange(item.outward_item_id)
    }/>
</td>
        <td>{item.outward_no}</td> 
        <td>{item.product_name}</td> 
        <td>{item.outward_qty}</td> 
        <td>₹ {item.price}</td> 
        <td> {new Date(item.outward_date).toLocaleDateString()} </td> 
        </tr> ))} 
        </tbody> 
        </table> )} 
        </ModalBody> 
        <ModalFooter> 
          <Button color="secondary" onClick={() => setInvoiceModal(false)} > Cancel </Button> 
          <Button color="primary" disabled={outwardSelectedItems.length === 0} 
          onClick={handleGenerateInvoice} > Generate Invoice </Button> 
        </ModalFooter> 
        </Modal>
    </>
  );
};

export default ManageInvoice;
